import { createAction } from 'typesafe-actions';
import { saveToLocalStorageHelper } from '../../helpers/saveToLocalStorageHelper';
import { localStorageKey } from '../../helpers/validateLocalStorage';

export const _updateCompanyVendor = createAction('shared/updateCompanyVendor')<
  string | null
>();

export const updateCompanyVendor = (
  companyVendor: string | null,
  saveToLocalStorage = true,
) => {
  saveToLocalStorageHelper({
    saveToLocalStorage,
    key: 'input',
    localStorageKey: localStorageKey.shared,
    input: {
      companyVendor,
    },
  });

  return _updateCompanyVendor(companyVendor);
};
